// extracted by mini-css-extract-plugin
export default {"container":"login_container__PoyEW","content":"login_content__1c5xO","logo":"login_logo__7E-qa","title":"login_title__zSOkE","titleText":"login_titleText__mF59o"};